// extracted by mini-css-extract-plugin
module.exports = {"ul":"album-module--ul--3K-Wm","li":"album-module--li--aP_-g","aspectRatio":"album-module--aspectRatio--3uO0s"};